module.exports = __webpack_public_path__ + "img/5.e9c11dd4.png";